















import MenuDrawer from '@/components/MenuDrawer'
import { mapState } from 'vuex'

export default 
	name: 'Content'
	
	components:
		'menu-drawer': MenuDrawer

	updated: ->
		@$nextTick ->
			componentHandler.upgradeElements @$el

	computed:
		mapState
			version: (state) ->
				state.version
			api_version: (state) ->
				if state.resources?
					state.resources.version
				else
					null

			isLoading: (state) ->
				state.xhr_is_loading
 



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Content.vue